<template>
  <v-card style="border-radius: 12px;" :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'" elevation="10">
    <v-card-title class="heading">
      <v-row align="center" class="ma-0">
        <span style="color: #47464A; font-weight: 600;">Marker</span>
        <v-spacer></v-spacer>
        <v-btn icon depressed @click="onEditClick" :disabled="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.33325 16.6666H6.66658L15.4166 7.91663C15.8586 7.47461 16.1069 6.87509 16.1069 6.24997C16.1069 5.62485 15.8586 5.02533 15.4166 4.5833C14.9746 4.14127 14.375 3.89294 13.7499 3.89294C13.1248 3.89294 12.5253 4.14127 12.0833 4.5833L3.33325 13.3333V16.6666Z"
              stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.25 5.41669L14.5833 8.75002" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed @click="onCloseClick" color="#47464A" :disabled="isDeleting">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Latitude:</div>
          <div style="margin-top: 10px; color: #47464A;">{{ Layer.getLatLng().lat | toFixed }}</div>
        </div>
        <v-divider></v-divider>
      </div>
      <div style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Longitude:</div>
          <div style="margin-top: 10px; color: #47464A;"> {{ Layer.getLatLng().lng | toFixed }}</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { FEATURE_CARD_STATE } from "../../../../helpers/geometries/constants"
import { FloatingCardsEventBus } from "../../../../helpers/mapview/events"
import { DIALOG_TYPES, DialogOptions } from "../../../../helpers/dialogs"
import { FEATURE_GROUPS } from "../../../../helpers/leaflet/constants"

const _MarkerMap = Symbol.for("_MarkerMap")
const _MarkerLayer = Symbol.for("_MarkerLayer")
const _MarkerFeature = Symbol.for("_MarkerFeature")

export default {
  name: "MarkerViewCard",
  inject: { _MarkerFeature, _MarkerLayer, _MarkerMap },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isDeleting: false,
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("close")
    },
    onDeleteClick() {
      this.$dialog(new DialogOptions({
        title: "Excluir Marcador",
        content: "Você tem certeza que quer excluir este marcador?",
        type: DIALOG_TYPES.CONFIRM,
        onConfirm: this.deleteHandler
      }))
    },
    deleteHandler() {
      const f = () => {
        this.Map.featureGroups[FEATURE_GROUPS.FEATURES].removeLayer(this.Layer)
        FloatingCardsEventBus.$emit("close")
      }

      this.isDeleting = true
      this.Feature.delete(this.Feature["id_processing_geometry"], f)
        .finally(() => {
          this.isDeleting = false
        })
    },
    onEditClick() {
      this.$emit("update:mode", FEATURE_CARD_STATE.EDIT)
    },
  },
  filters: {
    toFixed(value) {
      return value.toFixed(6)
    }
  },
  computed: {
    Map() {
      return this._MarkerMap()
    },
    Feature() {
      return this._MarkerFeature()
    },
    Layer() {
      return this._MarkerLayer()
    },
  },
}
</script>

<style scoped></style>
